import { PopupBlockedError } from 'errors'

export const HEADER_OPEN_LIVE_CHAT_EVENT = 'cms-open-live-chat'

declare global {
  interface DocumentEventMap {
    [HEADER_OPEN_LIVE_CHAT_EVENT]: CmsOpenLiveChatEvent
  }
}

interface CmsOpenLiveChatEventDetail {
  asPopup: boolean
  /**
   * @param error If set, an error occurred in calling the function and it failed
   */
  callback?: (error?: unknown | PopupBlockedError) => void
}

export class CmsOpenLiveChatEvent extends CustomEvent<CmsOpenLiveChatEventDetail> {
  constructor (asPopup: boolean, callback?: (e?: unknown) => void) {
    super(HEADER_OPEN_LIVE_CHAT_EVENT, {
      detail: {
        asPopup,
        callback
      }
    })
  }
}
